@import '../../helpers/helpers';

.buttonWrap {
  height: 40px;
  background: $inputBackground;
  border-radius: .25em;
  margin: 10px 0;
  cursor: pointer;
}

.plus {
  margin: 0 auto;

  &:hover {
    opacity: 0.3;
  }
}

.items {
  background: $inputBackground;
  border-radius: .25em;
  padding: .3em .75em;
}